import { render, staticRenderFns } from "./DnDTarget.vue?vue&type=template&id=75d59e61&"
import script from "./DnDTarget.vue?vue&type=script&lang=ts&"
export * from "./DnDTarget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports